import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Services } from "@/components/sections/Services";
import { Gallery } from "@/components/sections/Gallery";
import { Process } from "@/components/sections/Process";
import { Testimonials } from "@/components/sections/Testimonials";
import { Reviews } from "@/components/sections/Reviews";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <Process />
        <Testimonials />
        <Reviews />
      </main>
      <Footer />
    </div>
  );
}
